import { useDrugs } from '@hook'
import { DeleteModal } from '@ui'
import { getError, showToast } from '@util'
import { useState } from 'react'

type Props = {
  onClose: () => void
  isOpen: boolean
  id?: string
}

const RemoveDrug = ({ isOpen, onClose, id }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const { deleteDrug } = useDrugs()
  const handleClose = () => {
    onClose()
    setIsLoading(false)
  }
  const deleteHandler = async () => {
    setIsLoading(true)
    try {
      await deleteDrug({ id: id || '' })
      showToast('Drug deleted successfully')
      handleClose()
    } catch (error: any) {
      getError(error)
    }
    setIsLoading(false)
  }
  return (
    <>
      {isOpen && (
        <DeleteModal
          description="Confirm that you want to delete this drug"
          handleSubmit={deleteHandler}
          isLoading={isLoading}
          onClose={handleClose}
          title="Delete Drug"
        />
      )}
    </>
  )
}

export default RemoveDrug
